import { assignEmployeeDuty } from "@/features/modules/utility/modules/assignEmployeeDuty";
import { downloadHealthFolder } from "../modules/utility/modules/downloadHealthFolder";
import { exportEmployee } from "@/features/modules/utility/modules/exportEmployee";

export const featuresUtilityModules = [assignEmployeeDuty, downloadHealthFolder, exportEmployee];
